import type { InstallTexts } from '@symphenia/ui-components'

/**
 * AP-17-E — die Worte des ERP für die geteilten Installations-Bausteine.
 *
 * Am Desktop heißt das Ding beim Namen: Wer „Symphenia als App installieren"
 * liest, weiß, was auf dem Desktop landet. Die Safari-Menüleiste sitzt hier
 * oben — das ERP läuft praktisch nie am iPhone.
 */
export const INSTALL_TEXTS: InstallTexts = {
  appName: 'Symphenia',
  installLabel: 'Symphenia als App installieren',
}
